/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-09 10:43:35
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-17 17:28:56
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/ListAdaptor/index.tsx
 */
import React from 'react';

import css from './css.module.less';

import _ProductList from 'src/constrains/DraggableModules/Components/ProductList';
import _ArticleList from 'src/constrains/DraggableModules/Components/ArticleList';

import DataHOC from 'src/constrains/DraggableModules/Components/HOC/DataProcessHOC';

import { EnumModuleType } from 'src/types/common/module';
import AdaSelection from 'src/constrains/DraggableModules/Components/AdaptorSelection';

const ListAdaptor = (props) => {
  const { staticData, onModuleTypeChange, draggableId, allDisabled, ...rest } =
    props;

  const { moduleType } = staticData;

  const handleOnModuleTypeChange = (e) => {
    const type = e.target.value;

    const data = { moduleType: type, id: draggableId };
    if (onModuleTypeChange) {
      onModuleTypeChange(data);
    }
  };
  const Dict = React.useMemo(() => {
    return {
      [EnumModuleType.ProductList]: _ProductList,
      [EnumModuleType.ArticleList]: _ArticleList,
    };
  }, []);
  const generateModule = () => {
    const Module = Dict[moduleType];

    return (
      <Module
        {...rest}
        draggableId={draggableId}
        staticData={staticData}
        disabled={allDisabled}
      />
    );
  };
  return (
    <div className={css.container}>
      <AdaSelection
        title='List Type'
        list={[
          {
            value: EnumModuleType.ProductList,
            label: 'Product',
            className: css.radioItem,
          },
          {
            value: EnumModuleType.ArticleList,
            label: 'Content Page',
          },
        ]}
        value={moduleType}
        onChange={handleOnModuleTypeChange}
        disabled={allDisabled}
      />{' '}
      {/* <Section bottomBorder>
        <ItemWrapper title='Carousel Type'>
          <Radio
            className={css.radioContainer}
            radioList={[
              {
                value: EnumModuleType.Carousel,
                label: 'Carousel',
                className: css.radioItem,
              },
              {
                value: EnumModuleType.ProductCarousel,
                label: 'Product Carousel',
              },
            ]}
            value={moduleType}
            onChange={handleOnModuleTypeChange}
          />
        </ItemWrapper>
      </Section> */}
      {generateModule()}
    </div>
  );
};
export default DataHOC(ListAdaptor);
